module.exports = [{"type":"title","text":"2025-06-12"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures: The order placement API response now includes an ‘executedQty’ field."},{"type":"html","text":"USDT-M Perp Futures: Added ‘closePosition’ field to responses of both the single order details query and open orders query."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2025-06-12.json
// module id = I6Rl
// module chunks = 3